(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      format = format || '${{amount}}';

      function defaultOption(opt, def) {
        return (typeof opt === 'undefined' || opt === null) ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) return '0';

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
      }

      var value = '';
      var match = format.match(placeholderRegex);
      var placeholder = match ? match[1] : 'amount';

      switch (placeholder) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return format.replace(placeholderRegex, value);
    }

    function getQuantity(priceEl) {
      var scope = priceEl.closest('form[action*="/cart/add"]') ||
                  priceEl.closest('product-form-component') ||
                  priceEl.closest('.shopify-product-form') ||
                  document;
      var input = scope.querySelector('input[name="quantity"], quantity-selector input, .quantity-selector input');
      var qty = input ? parseInt(input.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      return qty;
    }

    function recalc(priceEl) {
      var unit = parseInt(priceEl.getAttribute('data-unit-price'), 10);
      if (isNaN(unit)) return;

      var format = priceEl.getAttribute('data-money-format') || '${{amount}}';
      var compare = parseInt(priceEl.getAttribute('data-unit-compare'), 10);
      var qty = getQuantity(priceEl);

      var html = '';
      if (!isNaN(compare) && compare > unit) {
        html += '<s>' + formatMoney(compare * qty, format) + '</s>';
      }
      html += formatMoney(unit * qty, format);

      if (priceEl.getAttribute('data-rendered') === html) return;
      priceEl.setAttribute('data-rendered', html);
      priceEl.innerHTML = html;
    }

    function recalcAll() {
      var els = document.querySelectorAll('.add-to-cart-price[data-unit-price]');
      for (var i = 0; i < els.length; i++) recalc(els[i]);
    }

    var debounceTimer;
    function recalcAllDebounced() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(recalcAll, 60);
    }

    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') recalcAll();
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') recalcAll();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest &&
          e.target.closest('quantity-selector, .quantity-selector, [class*="quantity"]')) {
        setTimeout(recalcAll, 30);
      }
    });

    function init() {
      recalcAll();
      var observer = new MutationObserver(recalcAllDebounced);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
